import { NAME} from './constants';

export const selectedDetailIncident = state => state[NAME].selectedDetailIncident